import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { displayOsloDate } from "./displayOsloDate";
import { momentLocaleFor } from "./i18nFormatters";

export const useDisplayOsloDate = () => {
  const { i18n } = useTranslation();
  const locale = momentLocaleFor(i18n.language);
  return useCallback((value: string) => displayOsloDate(value, locale), [locale]);
};
